import React from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';

export function generateMergeErrorMessage(errorCode: string) {
  switch (errorCode) {
    case 'too_many_messages':
    case 'too_many_activities':
      return <Trans id="merge-error-toobig">These conversations are too big to be merged.</Trans>;

    case 'has_drafts':
      return <Trans id="merge-error-drafts">Some conversations contain drafts.</Trans>;

    case 'multiple_message_types':
      return <Trans id="merge-error-messagetypes">Some messages have different types.</Trans>;

    default:
      return <Trans id="merge-error-unknown">These conversations could not be merged.</Trans>;
  }
}
